import Rollbar from 'rollbar'

const APP_VERSION =
  process.env.NEXT_PUBLIC_APP_VERSION ||
  process.env.APP_VERSION ||
  process.env.npm_package_version ||
  'dev'

const COMMON_SCRUB_FIELDS = [
  'authorization',
  'cookie',
  'set-cookie',
  'x-access-token',
  'token',
  'access_token',
  'refresh_token',
  'password',
  'secret',
]

const baseConfig = {
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: process.env.NODE_ENV,
  code_version: APP_VERSION,
  scrubFields: COMMON_SCRUB_FIELDS,
  payload: {
    environment: process.env.NODE_ENV,
    context: 'unknown',
  },
}

export const clientConfig = {
  accessToken: process.env.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN,
  ...baseConfig,
}

export const serverConfig = {
  accessToken: process.env.ROLLBAR_SERVER_TOKEN,
  ...baseConfig,
}

export const serverInstance = new Rollbar(serverConfig)
